(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cibernetica-header"]) return;
  try {
    
  const bindings = new WeakMap();
  function bindStickyHeader() {
    const header = document.querySelector('[data-cib-sticky]');
    if (!header || bindings.has(header)) return;
    const scroller = header.closest('.page-wrapper') || document.documentElement;
    const target = scroller === document.documentElement ? window : scroller;
    const controller = new AbortController();
    const sync = () => header.classList.toggle('is-scrolled', Math.max(scroller.scrollTop, window.scrollY) > 20);
    const resize = new ResizeObserver(() => {
      const height = header.getBoundingClientRect().height + 'px';
      scroller.style.setProperty('--cib-sticky-height', height);
      document.documentElement.style.setProperty('--cib-sticky-height', height);
      sync();
    });
    target.addEventListener('scroll', sync, { passive: true, signal: controller.signal });
    if (target !== window) window.addEventListener('scroll', sync, { passive: true, signal: controller.signal });
    header.addEventListener('click', (event) => {
      if (event.target.closest('nav a')) header.querySelector('.cib-mobile-menu')?.removeAttribute('open');
    }, { signal: controller.signal });
    resize.observe(header);
    sync();
    bindings.set(header, { controller, resize });
  }
  bindStickyHeader();
  document.addEventListener('shopify:section:load', bindStickyHeader);
  document.addEventListener('shopify:section:unload', (event) => {
    const header = event.target.querySelector('[data-cib-sticky]');
    const binding = header && bindings.get(header);
    if (binding) {
      binding.controller.abort();
      binding.resize.disconnect();
      bindings.delete(header);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
